<!--notice的容器-->
<template>
  <div :class="classes" :style="styles">
    <template v-if="type === 'notice'">
      <div v-for="(notice, index) in noticeList"
           v-if="notice.isShow"
           :key="index">
        <t-notice
          :prefix-cls="prefixCls"
          :styles="notice.styles"
          :content="notice.content"
          :duration="notice.duration"
          :closable="notice.closable"
          :name="notice.name"
          :time-out-id="notice.timeOutId"
          :transition-name="notice.transitionName"
          :on-close="notice.onClose"
          @notice-time-out="onTimeOutChange">
        </t-notice>
      </div>
    </template>
    <template v-else>
      <div v-for="(notice, index) in notices"
           v-if="notice.isShow"
           :key="index">
        <t-notice :prefix-cls="prefixCls"
                  :styles="notice.styles"
                  :content="notice.content"
                  :duration="notice.duration"
                  :closable="notice.closable"
                  :name="notice.name"
                  :time-out-id="notice.timeOutId"
                  :transition-name="notice.transitionName"
                  :on-close="notice.onClose"
                  @notice-time-out="onTimeOutChange">
        </t-notice>
      </div>
    </template>
  </div>
</template>
<script>
import TNotice from './notice.vue'
import * as constants from '../../../utils/constants'

const PREFIX_NOTICE_CLASS = `${constants.PREFIX_CLASS}notice`

let seed = 0
const now = Date.now()
function getUuid () {
  return 'aidNotification_' + now + '_' + (seed++)
}
export default {
  components: {TNotice},
  props: {
    prefixCls: {
      type: String,
      default: PREFIX_NOTICE_CLASS
    },
    styles: {
      type: Object,
      default: function () {
        return {
          top: '65px',
          left: '50%'
        }
      }
    },
    content: {
      type: String
    },
    className: {
      type: String
    },
    type: {
      type: String
    }
  },
  data () {
    return {
      notices: []
    }
  },
  computed: {
    classes () {
      return [
        `${this.prefixCls}`,
        {
          [`${this.className}`]: !!this.className
        }
      ]
    },
    noticeList () {
      let loticesReverse = []
      for (let i = this.notices.length - 1; i >= 0; i--) {
        loticesReverse.push(this.notices[i])
      }
      return loticesReverse
    }
  },
  methods: {
    add (notice) {
      const name = notice.name || getUuid()
      let _notice = Object.assign({
        styles: {
          right: '50%'
        },
        content: '',
        duration: 1.5,
        closable: false,
        name: name,
        isShow: true
      }, notice)
      this.notices.push(_notice)
      // this.notices.unshift(_notice)
    },
    close (name) {
      const notices = this.notices
      for (let i = 0; i < notices.length; i++) {
        if (notices[ i ].name === name) {
          this.notices[i]['isShow'] = false
          // this.notices.splice(i, 1)
          break
        }
      }
    },
    onTimeOutChange(timeOutId, name) {
      for (let i = 0; i < this.notices.length; i++) {
        if (this.notices[ i ].name === name) {
          this.notices[i]['timeOutId'] = timeOutId
          break
        }
      }
    },
    closeAll () {
      this.notices = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// notification.vue?9493498a